var exports = {
  "m": "xaf9ae18d--f3f4d9--mobile-banner",
};

module.exports = exports;
